const n = {
  name: "ChevronDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.00015 7.58594L12.0002 14.5859L19.0002 7.58594L20.4144 9.00015L12.0001 17.4144L3.58594 9.00015L5.00015 7.58594Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as ChevronDown
};
